import { render, staticRenderFns } from "./PublicationDetail.vue?vue&type=template&id=7215a927&scoped=true"
import script from "./PublicationDetail.vue?vue&type=script&lang=js"
export * from "./PublicationDetail.vue?vue&type=script&lang=js"
import style0 from "./PublicationDetail.vue?vue&type=style&index=0&id=7215a927&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215a927",
  null
  
)

export default component.exports